module.exports = __webpack_public_path__ + "img/package_alert.ba717ae1.svg";